import {
  Icon,
  isMobileAtom,
  KaKaoChannelIcon,
  useRecoil,
} from '@orcar/common-d2c';
import styled from 'styled-components';

type KakaoChannelButtonProps = {
  linkUrl: string;
};

const KakaoChannelButton = ({ linkUrl }: KakaoChannelButtonProps) => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  return (
    <Wrapper isMobile={isMobile}>
      <a target='_blank' href={linkUrl}>
        <Icon src={KaKaoChannelIcon} width={50} height={50}></Icon>
      </a>
    </Wrapper>
  );
};

export { KakaoChannelButton };

const Wrapper = styled.div<{ isMobile?: boolean }>`
  position: fixed;
  bottom: ${({ isMobile }) => (isMobile ? '24px' : '35px')};
  right: ${({ isMobile }) => (isMobile ? '24px' : '35px')};
  z-index: 5;
`;
